import { Text } from '@wix/design-system';
import React, { FC } from 'react';
import styles from './Webpage.scss';
import { OrderSmall, CircleSmallFilledSmall } from '@wix/wix-ui-icons-common';

type Props = {
  menuItems: string[];
  selectedMenuItemIndex: number;
  title?: string;
};

export const WebpageHeader: FC<Props> = ({ menuItems, selectedMenuItemIndex, title }) => {
  return (
    <div className={styles.webpageHeader}>
      <div className={styles.webpageHeaderTitle}>
        <Text size="small" weight="bold">
          {title}
        </Text>
      </div>
      <div className={styles.webpageHeaderActions}>
        <div className={styles.webpageHeaderMenu}>
          {menuItems.map((item, index) => (
            <Text key={item} secondary size="tiny" weight={index === selectedMenuItemIndex ? 'bold' : undefined}>
              {item}
            </Text>
          ))}
        </div>
        <OrderSmall />
      </div>
    </div>
  );
};
